import { Result, Button } from "antd";
import { useCustomOperate } from "@/hooks";

export default function NoteFound() {
  // 自定义操作
  const { customReplace } = useCustomOperate();

  return (
    <div className="p-4">
      <Result
        status="404"
        title="404"
        subTitle="对不起，当前访问的页面不存在"
        extra={
          <Button type="primary" onClick={() => customReplace(`/`)}>
            回到首页
          </Button>
        }
      />
    </div>
  );
}